<div class="container" style="padding-top: 50px;">
    <div class="row">
        <div class="col-xl-3 col-lg-2 col-md-1 d-none d-md-block "></div>
        <div class="col-xl-6 col-lg-8 col-md-10 col-12">
            @if (loadingClockStatus && !clockActionPerformed) {
                <div class="alert alert-info">
                    <span class="status-message"><img src="/Cache/images/icon_load.gif" alt="Loading..." /> Loading...</span>
                </div>
            }
            @if (requestingLocation && !clockActionPerformed) {
                <div class="alert alert-warning">
                    <span class="status-message">Obtaining Location</span>
                </div>
            }
            @if (!requestingLocation && !clockActionPerformed) {
                <div>
                    @if (!geolocationEnabled) {
                        <span class="alert alert-danger status-message">Location Not Available</span>
                    }
                    @if (position != null) {
                        <span class="alert alert-success status-message">
                            Location Found.&nbsp;
                            @if (showProcessing()) {
                                <span>Processing...</span>
                            }
                        </span>
                    }
                </div>
            }
            @if (mealBreak && !canMealBreakClockIn()) {
                <div>
                    <span class="alert alert-danger">
                        You last clocked out on your meal break at {{lastClockDisplay}}. You must wait {{getMealBreakMinutes(employeeInfo.PRCo, employeeInfo.PRGroup)}} minutes after clocking out before clocking in from a meal break.
                    </span>
                </div>
            }
            @if (alert) {
                <div class="alert" [ngClass]="'alert-' + (alert.type || 'default')" role="alert">
                    {{alert.msg}}
                    <button type="button" class="close" (click)="closeAlert()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            }
            @if (clockActionPerformed && !hasWarning) {
                <div>
                    @if (!clockActionSuccess) {
                        <span class="alert alert-danger status-message">{{message}}</span><br />
                    }
                    @if (clockActionSuccess) {
                        <div class="alert alert-success" style="display: block">
                            <span class="status-message">{{message}}</span><br />
                            <span class="status-message">Redirecting back to login page...</span>
                        </div>
                    }
                </div>
            }
            @if (clockStatus && showMealBreak() && !clockActionPerformed) {
                <div>
                    <label><strong>Meal Break:</strong></label>
                    <ng-select class="field-select" [(ngModel)]="formData.mealBreak" name="mealBreak" [items]="mealBreakOptions" bindLabel="DisplayValue" bindValue="DatabaseValue" [clearable]="false">
                    </ng-select>
                </div>
            }
            @if (clockActionPerformed && (!clockActionSuccess || hasWarning)) {
                <button (click)="performLoginRedirect()" class="btn btn-primary action-button">Back</button>
            }
            @if (!kioskLogin && clockActionPerformed && clockActionSuccess) {
                <a href="/Home/Index" class="btn btn-primary action-button">Stay logged in</a>
            }
            <!--Regular clock handling if not restricted by meal break-->
            @if (showRegularClockInButtons()) {
                @if (requestingLocation || !geolocationEnabled) {
                    <button type="button" class="btn btn-danger" [disabled]="performingClockAction" (click)="postClockAction(true)">
                        Clock In/Out Without Location
                    </button>
                }
                @if (!requestingLocation && position != null) {
                    <button type="button" class="btn btn-success" [disabled]="performingClockAction" (click)="postClockAction(false)">
                        Clock In/Out
                    </button>
                }
            }
            <!--Handling if clocking in early from a meal break-->
            @if (showClockinfromMealBreak()) {
                <strong>Are you sure you want to clock in?</strong>
                @if (requestingLocation || !geolocationEnabled) {
                    <button type="button" class="btn btn-danger" [disabled]="performingClockAction" (click)="postClockAction(true)">
                        Yes, Clock In Without Location
                    </button>
                }
                @if (!requestingLocation && position != null) {
                    <button type="button" class="btn btn-success" [disabled]="performingClockAction" (click)="postClockAction(false)">
                        Yes, Clock In
                    </button>
                }
                <button type="button" class="btn btn-outline-dark" (click)="performLoginRedirect()">
                    Cancel
                </button>
            }
        </div>
    </div>

    @if (requireSign && clockStatus && !(!kioskLogin && clockActionPerformed) && !clockActionPerformed) {
        <div class="row">
            <div class="col-xl-3 col-lg-2 col-md-1 d-none d-md-block"></div>
            <div class="col-xl-6 col-lg-8 col-md-10 col-12">
                @if (customMsg != null) {
                    <div class="alert alert-warning">
                        <quill-view disabled [content]="customMsg"></quill-view>
                    </div>
                }
                <div class="card border" style="max-width: 580px; width: 100%; margin-bottom: 20px;">
                    <div class="card-body" style="max-width: 580px; width: 100%; background-color:#d4d4d4;border:1px solid black;border-radius:5px;">
                        @if (showClickMsg) {
                            <div class="alert alert-info m-signature-pad__notice">Press "Clear" before generating your signature image.</div>
                        }
                        <div class="m-signature-pad">
                            <div class="m-signature-pad--body" [ngClass]="{ 'invalid': redBorder }" [hidden]="submitSignImg != null">
                                <signature-pad [options]="signaturePadOptions" #signaturePad></signature-pad>
                            </div>
                            @if (submitSignImg != null) {
                                <div style="background-color:white;border:1px solid black">
                                    <img [src]="submitSignImg" style="max-width: calc(100% - 50px);" />
                                </div>
                            }
                            <div class="m-signature-pad--footer">
                                <div style="text-align: center;font-size: 12px;">Sign above</div>
                                <button type="button" class="btn btn-outline-dark" (click)="clear()">Clear</button>
                                @if (!hideClick) {
                                    <button type="button" class="btn btn-outline-dark" (click)="clickSign('full')">Generate Signature</button>
                                }
                                <div class="alert alert-warning m-signature-pad__notice">By signing above, I agree that the signature and initials will be the electronic representation of my signature and initials for all purposes when I (or my agent) use them on documents, including legally binding contracts - just the same as a pen-and-paper signature or initial.</div>
                            </div>
                        </div>
                    </div>
                </div>
                <button class="btn btn-success" type="button" (click)="clockOutClicked()" [disabled]="disableSubmitSign">Submit Clock-Out</button>
            </div>
        </div>
    }
    @if (showClockInTypes()) {
        <div class="row">
            <div class="col-xl-3 col-lg-2 col-md-1 d-none d-md-block"></div>
            <div class="col-xl-6 col-lg-8 col-md-10 col-12">
                <div class="card border">
                    <div class="card-body row">
                        <div class="d-none d-lg-block col-xl-2 col-lg-2"></div>
                        <div class="col-xl-8 col-lg-8 col-md-12 col-12">
                            @if (types().length > 1) {
                                <div>
                                    <label><strong>Type:</strong></label>
                                    <ng-select class="field-select"
                                               [items]="types()"
                                               bindLabel="DisplayValue"
                                               bindValue="Value"
                                               [clearable]="false"
                                               [(ngModel)]="formData.selectedType"
                                               dropdownPosition="bottom"
                                               (change)="typeChanged()">
                                    </ng-select>
                                </div>
                            }
                            @if (formData.selectedType === 'J') {
                                <app-job-type-dropdown [inputJob]="formData.selectedJob"
                                                       [inputPhase]="formData.selectedPhase"
                                                       [inputEquipment]="formData.selectedEquipment"
                                                       [employeeInfo]="employeeInfo"
                                                       (dropdownChanged)="onJobDropdownChange($event)">
                                </app-job-type-dropdown>
                            }
                            @if (formData.selectedType === 'S') {
                                <label><strong>Trip:</strong></label>
                                <ng-select class="field-select"
                                           [items]="workOrderList"
                                           bindLabel="Display"
                                           [clearable]="false"
                                           [(ngModel)]="formData.selectedWorkOrder"
                                           dropdownPosition="bottom"
                                           (change)="workOrderChanged()"
                                           [searchable]="true">
                                </ng-select>
                                <label><strong>Scope:</strong></label>
                                <ng-select class="field-select"
                                           [items]="scopeList"
                                           bindLabel="Display"
                                           [clearable]="false"
                                           [(ngModel)]="formData.selectedScope"
                                           dropdownPosition="bottom"
                                           [searchable]="true">
                                </ng-select>
                                <label><strong>Pay Type:</strong></label>
                                <ng-select class="field-select"
                                           [items]="payTypeList"
                                           bindLabel="Display"
                                           [clearable]="false"
                                           [(ngModel)]="formData.selectedPayType"
                                           dropdownPosition="bottom"
                                           [searchable]="true">
                                </ng-select>
                            }
                            @if (formData.selectedType === 'M') {
                                <app-mechanical-dropdown (dropdownChanged)="onMechanicDropdownChange($event)"></app-mechanical-dropdown>
                            }
                            <div class="row">
                                <div class="col-lg-12">
                                    <!--Regular clock handling if not restricted by meal break-->
                                    @if (!mealBreak || canMealBreakClockIn()) {
                                        @if (requestingLocation || !geolocationEnabled) {
                                            <button type="button" class="btn btn-danger" [disabled]="disableClockInButton()" (click)="postClockAction(true)">
                                                Clock In Without Location
                                            </button>
                                        }
                                        @if (performingClockAction) {
                                            <img src="/Cache/images/icon_load.gif" alt="Loading..." />
                                        }
                                        @if (!requestingLocation && position != null) {
                                            <button type="button" class="btn btn-success" [disabled]="disableClockInButton()" (click)="postClockAction(false)">
                                                Clock In
                                            </button>
                                        }
                                    }
                                    <!--Handling if clocking in early from a meal break-->
                                    @if (mealBreak && !canMealBreakClockIn()) {
                                        <strong>Are you sure you want to clock in?</strong>
                                        @if (requestingLocation || !geolocationEnabled) {
                                            <button type="button" class="btn btn-danger" [disabled]="disableClockInButton()" (click)="postClockAction(true)">
                                                Yes, Clock In Without Location
                                            </button>
                                        }
                                        @if (performingClockAction) {
                                            <img src="/Cache/images/icon_load.gif" alt="Loading..." />
                                        }
                                        @if (!requestingLocation && position != null) {
                                            <button type="button" class="btn btn-success" [disabled]="disableClockInButton()" (click)="postClockAction(false)">
                                                Yes, Clock In
                                            </button>
                                        }
                                        <button type="button" class="btn btn-outline-dark" (click)="performLoginRedirect()">
                                            Cancel
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="d-none d-lg-block col-xl-2 col-lg-2"></div>
                    </div>
                </div>
            </div>
        </div>
    }
</div>